import { merge } from 'lodash';
import { DeploymentEnv, FrontendCommonConfig, getDeploymentEnvironment } from '~frontend-common/config';
import { SentryEnvironment } from '~frontend-common/helper/core/sentry';
import configJson from '../../config.json';

type WebPortalEnvConfig = Readonly<{
  sentry: {
    dsn: string;
    environment: SentryEnvironment;
  };
  clarityProjectId: string;
  helpScoutBeaconId: string;
}>;

const environmentConfigs = configJson as Record<DeploymentEnv, WebPortalEnvConfig>;

export const FrontendWebPortalConfig = merge(
  {},
  FrontendCommonConfig,
  environmentConfigs[getDeploymentEnvironment()] || {},
) as typeof FrontendCommonConfig & WebPortalEnvConfig;
